import { FileInterface } from "../../../../types/RecordInterfaces";
import AppSpinner from "../../../../elements/AppSpinner";

const ImageCardUploading = ({ file }: { file: FileInterface }) => {
  return (
    <div
      style={{
        width: "210px",
        height: "180px",
        boxShadow: "rgba(0, 0, 0, 0.15) 0px 2px 8px",
        borderRadius: "4px",
      }}
      className="m-1 p-2"
    >
      <div style={{ height: 25 }} className="mb-1"></div>
      <div
        style={{ width: "190px", height: "110px" }}
        className="m-0 p-0 d-flex flex-column justify-content-center align-items-center"
      >
        <AppSpinner size="lg" />
      </div>
      <p className="mx-1 my-1 text-truncate text-dark text-sm font-weight-500">
        {file?.Name}
      </p>
    </div>
  );
};

export default ImageCardUploading;
